const menuItems = {
  items: [
    {
      id: "landing",
      title: "Landing",
      type: "group",
      icon: "icon-support",
      children: [
        {
          id: "landing-page",
          title: "Recommendation Dashboard",
          type: "item",
          icon: "feather icon-navigation-2",
          classes: "nav-item",
          url: `${process.env.REACT_APP_RECOMMENDATION_DASHBOARD_URL}`,
          target: true,
          external: true,
        },
      ],
    },
  ],
};

export default menuItems;
